import { colors } from "material-ui/styles";

const primaryButtonColors = {
    iconColor: '#FFFFFF',
    iconColorDisabled: 'rgba(0, 0, 0, 0.25)',
    iconColorPressed: '#FFFFFF',

    textColor: '#FFFFFF',
    textColorDisabled: 'rgba(0, 0, 0, 0.25)',
    textColorPressed: '#FFFFFF',

    backgroundColor: colors.blue500, // rgb(33, 150, 243)
    backgroundColorPressedDisabled: 'rgba(0, 0, 0, 0.0125)',
    backgroundColorPressed: colors.blue500, // rgb(33, 150, 243)
    backgroundColorActive: colors.blue500, // rgb(33, 150, 243)
    backgroundColorHover: 'rgb(114, 185, 242)', // rgb(33, 150, 243) + a rgba(236, 238, 241, 0.4) overlay

    shadowColorDisabled: 'rgba(0, 0, 0, 0.0375)',
    shadowColor: 'rgba(0, 0, 0, 0.15)',

    rippleColor: 'rgb(236, 238, 241)'
};

const secondaryButtonColors = {
    iconColor: '#FFFFFF',
    iconColorDisabled: 'rgba(255, 255, 255, 0.25)',
    iconColorPressed: '#FFFFFF',

    textColor: '#FFFFFF',
    textColorDisabled: 'rgba(255, 255, 255, 0.25)',
    textColorPressed: '#FFFFFF',

    backgroundColor: 'transparent',
    backgroundColorPressedDisabled: 'rgba(0, 0, 0, 0.0125)',
    backgroundColorPressed: 'rgba(0, 0, 0, 0.25)',
    backgroundColorActive: colors.blue500, // rgb(33, 150, 243)
    backgroundColorHover: 'rgb(114, 185, 242)', // rgb(33, 150, 243) + a rgba(236, 238, 241, 0.4) overlay

    shadowColorDisabled: 'rgba(0, 0, 0, 0.0375)',
    shadowColor: 'rgba(0, 0, 0, 0.15)',

    rippleColor: 'rgb(236, 238, 241)'
};

export default {
    default: (isPrimary: boolean, isSecondary = false) => {
        if (isPrimary) {
            return primaryButtonColors;
        }
        if (isSecondary) {
            return secondaryButtonColors;
        }
        return {
            iconColor: 'rgba(0, 0, 0, 0.54)',
            iconColorDisabled: 'rgba(0, 0, 0, 0.25)',
            iconColorPressed: 'rgba(0, 0, 0, 0.54)',

            textColor: 'rgba(0, 0, 0, 0.54)',
            textColorDisabled: 'rgba(0, 0, 0, 0.25)',
            textColorPressed: 'rgba(0, 0, 0, 0.54)',

            backgroundColor: 'transparent',
            backgroundColorPressedDisabled: 'rgba(0, 0, 0, 0.0125)',
            backgroundColorPressed: 'rgba(0, 0, 0, 0.05)',
            backgroundColorActive: '#FFFFFF',
            backgroundColorHover: 'rgba(255, 255, 255, 0.5)',

            shadowColorDisabled: 'rgba(0, 0, 0, 0.0375)',
            shadowColor: 'rgba(0, 0, 0, 0.15)',

            rippleColor: colors.blue500 // rgb(33, 150, 243)
        };
    },

    alternative: (isPrimary: boolean) => {
        if (isPrimary) {
            return primaryButtonColors;
        }
        return {
            iconColor: 'rgba(0, 0, 0, 0.54)',
            iconColorDisabled: 'rgba(0, 0, 0, 0.25)',
            iconColorPressed: 'rgba(0, 0, 0, 0.54)',

            textColor: 'rgba(0, 0, 0, 0.54)',
            textColorDisabled: 'rgba(0, 0, 0, 0.25)',
            textColorPressed: 'rgba(0, 0, 0, 0.54)',

            backgroundColor: 'transparent',
            backgroundColorPressedDisabled: 'rgba(0, 0, 0, 0.0125)',
            backgroundColorPressed: 'rgba(0, 0, 0, 0.05)',
            backgroundColorActive: 'rgba(227, 242, 253, 1)',
            backgroundColorHover: 'rgba(227, 242, 253, 0.5)',

            shadowColorDisabled: 'rgba(0, 0, 0, 0.0375)',
            shadowColor: 'rgba(0, 0, 0, 0.15)',

            rippleColor: colors.blue500 // rgb(33, 150, 243)
        };
    },

    light: () => {
        return {
            iconColor: 'rgba(255, 255, 255, 1)',
            iconColorDisabled: 'rgba(255, 255, 255, 0.25)',
            iconColorPressed: 'rgba(255, 255, 255, 1)',

            textColor: 'rgba(255, 255, 255, 1)',
            textColorDisabled: 'rgba(255, 255, 255, 0.25)',
            textColorPressed: 'rgba(255, 255, 255, 1)',

            backgroundColor: 'transparent',
            backgroundColorPressedDisabled: 'rgba(0, 0, 0, 0.0125)',
            backgroundColorPressed: 'rgba(0, 0, 0, 0.05)',
            backgroundColorActive: '#000',
            backgroundColorHover: 'rgba(0, 0, 0, 0.5)',

            shadowColorDisabled: 'rgba(0, 0, 0, 0.0375)',
            shadowColor: 'rgba(0, 0, 0, 0.15)',

            rippleColor: colors.blue500 // rgb(33, 150, 243)
        };
    }
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/icon-text-button/colors.ts
 **/